import React from "react";

import { useAppSelector } from "store";
import {
    chooseAllCompetitorCategories,
    deselectAllCompetitorCategories,
    selectCompetitorCategories,
    toggleCompetitorCategoryIsSelected
} from "modules/customer/tools/location/competition/competitionSlice";
import MultiSelectFilter from "components/filters/MultiSelectFilter";

const CompetitorCategoriesFilter: React.FC = () => {
    const competitorCategories = useAppSelector(selectCompetitorCategories);
    return (
        <MultiSelectFilter
            title="Store categories"
            items={competitorCategories}
            chooseAllItems={chooseAllCompetitorCategories}
            deselectAllItems={deselectAllCompetitorCategories}
            toggleItemIsSelected={toggleCompetitorCategoryIsSelected}
        />
    );
};

export default CompetitorCategoriesFilter;
